export default __webpack_public_path__ + "static/media/social_deck.b975e1b1.svg";